import type { SVGProps } from 'react';

export function UsersIcon({ className, ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...props}
    >
      <g clipPath="url(#clip0_6180_13668)">
        <path
          d="M11 7C12.1067 7 12.9933 6.10667 12.9933 5C12.9933 3.89333 12.1067 3 11 3C9.89333 3 9 3.89333 9 5C9 6.10667 9.89333 7 11 7ZM5.66667 7C6.77333 7 7.66 6.10667 7.66 5C7.66 3.89333 6.77333 3 5.66667 3C4.56 3 3.66667 3.89333 3.66667 5C3.66667 6.10667 4.56 7 5.66667 7ZM5.66667 8.33333C4.11333 8.33333 1 9.11333 1 10.6667V11.6667C1 12.0333 1.3 12.3333 1.66667 12.3333H9.66667C10.0333 12.3333 10.3333 12.0333 10.3333 11.6667V10.6667C10.3333 9.11333 7.22 8.33333 5.66667 8.33333ZM11 8.33333C10.8067 8.33333 10.5867 8.34667 10.3533 8.36667C10.3667 8.37333 10.3733 8.38667 10.38 8.39333C11.14 8.94667 11.6667 9.68667 11.6667 10.6667V11.6667C11.6667 11.9 11.62 12.1267 11.5467 12.3333H15C15.3667 12.3333 15.6667 12.0333 15.6667 11.6667V10.6667C15.6667 9.11333 12.5533 8.33333 11 8.33333Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_6180_13668">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
